import { configureStore } from '@reduxjs/toolkit';
import authReducer from './redux/slices/authSlice';
import teacherDataReducer from './redux/slices/teacherDataSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    teacherData: teacherDataReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export default store; 